exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-kanban-header[data-v-732f9d24]{border-bottom:2px solid var(--orange)}.order-kanban-header__info[data-v-732f9d24]{flex:1;padding:10px}.order-kanban-header__action[data-v-732f9d24]{display:flex;flex-direction:column;padding:10px}", ""]);

// exports
